<template>
    <base-dialog-button :isOpen="dialogOpen" :size="'md'" :ariaLabel="$t('validation.tax_id_error.header')" :closable="false">
      <template slot="header">
        <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
          <div class="flex items-center">
            <h2 class="font-bold ml-2">
                {{ $t('validation.tax_id_error.header') }}
                <span v-if="taxId"> ({{ taxId }})</span>
            </h2>
          </div>
        </div>
      </template>
      <template slot="main">
        <div class="my-4">
          <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ message }}</span>
          <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ $t('clients.api_keys.delete_continue') }}</span>
        </div>
      </template>
    <template slot="footer">
      <div class="flex flex-row w-full justify-between">
        <base-button class="w-full mx-2" @click="cancelar()" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
        <base-button class="w-full mx-2" @click="confirmar()" mode="secondary-phantom-blue" :text="confirmLabel"/>
      </div>
    </template>
  </base-dialog-button>
</template>
<script>
import { i18n } from '@/i18n'
export default
{
  name: 'bad-tax-id-dialog',
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
    taxId: {
      type: String,
      default: ''
    },
    taxIdType: {
      type: String,
      default: ''
    },
    identifierFieldConfig: {
      type: Object,
      default: () => ({
        fieldLabel: '',
        allowedTypes: []
      })
    },
    confirmLabel: {
      type: String,
      default: i18n.t('app.save_and_continue')
    }
  },
  data: function () {
    return {
    }
  },
  computed: {
    message () {
      const types = (Array.isArray(this.identifierFieldConfig.allowedTypes) ? this.identifierFieldConfig.allowedTypes : [this.identifierFieldConfig.allowedTypes]).filter(Boolean)
      if (types.length === 0 || !this.taxIdType) {
        return i18n.t('validation.tax_id_error.bad_tax_id_format')
      }
      if (types.includes(this.taxIdType)) {
        return i18n.t('validation.tax_id_error.bad_control_character')
      }
      return i18n.t('validation.tax_id_error.bad_tax_id_type', { taxIdType: this.taxIdType, expectedType: this.identifierFieldConfig.fieldLabel })
    }
  },
  methods: {
    confirmar () {
      this.$emit('applyDialog')
      this.$emit('toggleDialog')
    },
    cancelar () {
      this.$emit('toggleDialog')
    },
  },
}
</script>   
<style lang="scss" scoped></style>
